module.exports = __webpack_public_path__ + "img/blake-1.5f6f0f4e.jpg";